<template>
  <a :href="value.btnAction" target="_blank" class="btn">
    <i>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="8.1 11 13.7 5.4 12.3 4 4.3 12 12.3 20 13.7 18.6 8.1 13 20.3 13 20.3 11"
          transform="translate(-4 -4)"
          fill="#668C9F"
          fill-rule="evenodd"
        />
      </svg>
    </i>
    {{ value.btnTxt }}
  </a>
</template>

<script>
  export default {
    props: ['value'],
  };
</script>
